<template>
    <span class="lang-en"><the-text-view :value="value"/></span>
</template>

<script>


    import TheTextView from './TheTextView'


    export default {
        name: 'TheEnglish',
        components: {
            TheTextView
        },
        data() {
            return {

            }
        },
        props: {
            value: String
        }
    }
</script>